<template>
  <div
    class="d-flex flex-column align-items-start justify-content-start studio-lesson-card border rounded p-3"
    :class="{ 'is-selected': isSelected }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div
      class="d-flex flex-row align-items-start justify-content-between w-100"
    >
      <div
        class="left d-flex flex-column align-items-start justify-content-start"
      >
        <div class="c-charcoal">
          {{ lesson.lesson_name }}
        </div>
        <!--        <div class="smaller mt-2">-->
        <!--          {{ $t('PRODUCTS.LABELS.LESSON', { txt: `${index}/${total}` }) }}-->
        <!--        </div>-->
        <div class="smaller mt-2" v-if="getStartText">
          <i class="fal fa-calendar mr-2 c-coral"></i>{{ getStartText }}
        </div>
      </div>
      <div
        class="ml-2 right d-flex flex-column align-items-center justify-content-end"
      >
        <div v-if="isLocked" class="icon-circle bg-brand-color-01">
          <i class="fal fa-lock-alt small"></i>
        </div>
        <div
          v-if="!isLocked && lesson.completed"
          class="icon-circle bg-brand-color-01"
        >
          <i class="fa fa-check c-brand-color small"></i>
        </div>
        <div class="display-chevron-down">
          <i class="fal fa-chevron-down"></i>
        </div>
        <div class="display-chevron-up">
          <i class="fal fa-chevron-up"></i>
        </div>
      </div>
    </div>
    <slot class="d-block d-md-none"></slot>
  </div>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import { formatDate } from '@/web/utils/format';
import * as Product from '@/core/utils/products';

export default Vue.extend({
  name: 'StudioLessonCard',
  props: {
    lesson: {
      type: Object,
    },
    index: {
      type: Number,
    },
    total: {
      type: Number,
    },
    isSelected: {
      type: Boolean,
    },
    hasAccess: {
      type: Boolean,
    },
  },
  computed: {
    isLocked() {
      return !this.hasAccess || this.lesson.locked;
    },
    getStartText() {
      const startType = this.lesson.lesson_start_type;
      const lessonType = this.findLessonTypeByValue(startType);
      if (startType === Product.LESSON_START_TYPE_AFTER_SPECIFIC_DAYS) {
        if (this.lesson.lesson_available_after_date) {
          return formatDate(
            this.lesson.lesson_available_after_date,
            'date-word'
          );
        } else {
          const days = this.lesson.lesson_start_after_days;
          return this.$tc('PRODUCTS.LABELS.AFTER_DAYS_VARIANT', days, { days });
        }
      } else if (startType === Product.LESSON_START_TYPE_AFTER_SPECIFIC_DATE) {
        return formatDate(this.lesson.lesson_available_after_date, 'date-word');
      } else if (lessonType) {
        return this.$t(lessonType.display_name_const);
      }
      return null;
    },
    lessonStartTypes() {
      return [
        {
          display_name_const: 'PRODUCTS.LABELS.WITH_PRODUCT_PURCHASE',
          value: Product.LESSON_START_TYPE_AFTER_PURCHASE,
        },
        {
          display_name_const:
            'PRODUCTS.LABELS.AFTER_PREVIOUS_LESSON_IS_COMPLETE',
          value: Product.LESSON_START_TYPE_AFTER_PREVIOUS_LESSON,
        },
        {
          display_name_const:
            'PRODUCTS.LABELS.AFTER_A_SPECIFIED_NUMBER_OF_DAYS',
          value: Product.LESSON_START_TYPE_AFTER_SPECIFIC_DAYS,
        },
        {
          display_name_const: 'PRODUCTS.LABELS.AFTER_A_SPECIFIED_DATE',
          value: Product.LESSON_START_TYPE_AFTER_SPECIFIC_DATE,
        },
      ];
    },
  },
  methods: {
    findLessonTypeByValue(value) {
      return _.find(this.lessonStartTypes, { value: value });
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.studio-lesson-card {
  cursor: pointer;

  .display-chevron-down,
  .display-chevron-up {
    display: none;
  }

  .icon-circle {
    text-align: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  &:hover {
    background-color: $lightest-gray;
  }
  &.is-selected {
    background-color: $lightest-gray;
  }

  /* Only display chevrons on small devices, where the collapsible content is present */
  @include media-breakpoint-down(sm) {
    &.collapsed {
      .display-chevron-down {
        display: block;
      }
    }
    &.not-collapsed {
      .display-chevron-up {
        display: block;
      }
    }
  }
}
</style>
